module.exports = __webpack_public_path__ + "static/media/search.8735f504.svg";